import React from "react";
import { CheckboxFilter } from "../components/checkboxFilter";
import { SliderFilter } from "../components/sliderfilter";
import { LeftFilterItems } from "../models/API";
import { FiltersStateType } from "../models/filters";

interface FilterDataProps {
  filterData: LeftFilterItems[];
  filterHeader: string;
  filterState: FiltersStateType;
  setFilterState: React.Dispatch<React.SetStateAction<FiltersStateType>>;
}
export const Filters = (props: FilterDataProps) => {
  const filters = props.filterData.map((filter) => {
    if (filter.Type === "checkboxes") {
      return (
        <CheckboxFilter
          name={filter.Name}
          values={filter.Values}
          id={filter.Key}
          key={filter.Id}
          dataState={props.filterState}
          setDataState={props.setFilterState}
          tooltip={filter.IsTooltipVisible && filter.TooltipContent}
        />
      );
    } else if (filter.Type === "slider") {
      return (
        <SliderFilter
          name={filter.Name}
          values={filter.Values}
          id={filter.Key}
          key={filter.Id}
          dataState={props.filterState}
          setDataState={props.setFilterState}
          tooltip={filter.IsTooltipVisible && filter.TooltipContent}
        />
      );
    } else {
      // TODO radio (singleChoice) if needed
      return null;
    }
  });

  return (
    <div className="filter-holder">
      <h2>{props.filterHeader}</h2>
      {filters}
    </div>
  );
};
